"use strict";

exports.__esModule = true;
exports.CurrentClassificationSubscriptions = void 0;
var _react = _interopRequireWildcard(require("react"));
var _timelineDefinitions = require("../timelineDefinitions");
var _TimelineSubscription = require("../TimelineSubscription");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * One TimelineSubscription per device. Memoized so parent state updates
 * that only change deviceStates do not remount subscriptions.
 */
var CurrentClassificationSubscriptions = exports.CurrentClassificationSubscriptions = /*#__PURE__*/(0, _react.memo)(function CurrentClassificationSubscriptions(_ref) {
  var deviceUuids = _ref.deviceUuids,
    onDeviceState = _ref.onDeviceState;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, deviceUuids.map(function (deviceUuid) {
    return /*#__PURE__*/_react["default"].createElement(_TimelineSubscription.TimelineSubscription, {
      key: deviceUuid,
      timelineName: _timelineDefinitions.TIME_SERIES_CLASSIFICATION,
      query: {
        device: deviceUuid
      },
      isCurrent: true,
      onData: function onData(packet) {
        return onDeviceState(deviceUuid, packet);
      }
    }, function () {
      return null;
    });
  }));
});